module.exports = __webpack_public_path__ + "static/media/person_icon.0cbdd004.png";